<template>
  <div class="question" :style="{ height: screenHeight }">
    <AppNavbar
      v-if="isApp"
      :options="options"
      :placeholder="true"
      :zIndex="999"
      :title="title"
    >
    </AppNavbar>
    <div class="container" v-if="questionData">
      <QuestionSteps
        class="steps-ponent"
        :index="questionData.questionIndex"
        :total="questionData.question.length"
        @pre="bindPreQuestion"
        :theme="questionData.theme"
      />
      <div class="question-content">
        <div class="que-content">
          <QuestionItem
            v-if="
              questionData.question &&
              questionData.question.length &&
              questionData.question[questionData.questionIndex]
            "
            :data="questionData.question[questionData.questionIndex]"
            @change="bindChange"
            :theme="questionData.theme"
          />
        </div>
        <div class="btn-content" v-if="showBtn">
          <div
            class="next-step"
            :style="{ background: questionData.theme.btnColor }"
            v-show="showNext"
            @click="bindNextQuestion"
            >确定</div
          >
          <div
            class="confirm"
            v-show="questionData.finished"
            @click="bindConfirm"
            :style="{ background: questionData.theme.btnColor }"
            v-buried
            data-buried="BG_KXWENJUAN_TIJIAO"
            v-clickBuried
            data-click-buried="CLICK_KXWENJUAN_TIJIAO"
            >提交</div
          >
        </div>
      </div>
    </div>
    <van-overlay :show="showToast" z-index="3000">
      <div class="wrapper" @click.stop v-if="toastData">
        <img class="w-image" :src="toastData.image" alt="" />
        <div class="w-title" v-if="toastData.title">{{ toastData.title }}</div>
        <div class="w-content">
          <div class="w-text" v-html="toastData.text"></div>
          <div class="w-btn" @click="closeToast">确认</div>
        </div>
      </div>
    </van-overlay>
    <AppLoading class="loading" v-if="!loaded" />
  </div>
</template>
<script>
import { Question } from './question.js'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import QuestionSteps from './components/steps.vue'
import QuestionItem from './components/question-item.vue'
import AppLoading from '@/components/app/loading/loading'
export default {
  components: {
    QuestionSteps,
    QuestionItem,
    AppLoading,
    AppNavbar
  },
  data() {
    return {
      isApp: false,
      screenHeight: 0,
      options: {
        barBackgroundColor: '#ffffff',
        color: 'rgba(0,0,0,0.8)'
      },
      loaded: false,
      questionData: null,
      showToast: false,
      toastData: null,
      toastObj: [
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cb21241d985a793523eb811a8df51f49.png',
          text: '很高兴与优秀的你相遇，或许接下来，坚持达成目标可能有点难，好消息是，betterWE会让一切变得简单！'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3b8a0baef456d776837cdd4c2002d81b.png',
          text: '你可以做的比想象中更好，接下来，betterWE将和您一起好好吃饭，有效减脂！'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fb80c167558a0d37aa2ac3cfe07bfe25.png',
          title: '健康提醒',
          text: '由于本问卷食谱基于高蛋白的饮食原则，现阶段我们的饮食禁忌较多，可能不适用您，建议优先就医改善健康指标，或咨询注册营养师做进一步的营养评估。'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fb80c167558a0d37aa2ac3cfe07bfe25.png',
          title: '健康提醒',
          text: '由于本问卷食谱基于高蛋白的饮食原则，现阶段我们的饮食禁忌较多，可能不适用您，建议咨询注册营养师做进一步的营养评估。'
        }
      ]
    }
  },
  computed: {
    title() {
      return '科学定制营养方案'
    },
    showBtn() {
      return (
        this.questionData.finished ||
        this.questionData.question[this.questionData.questionIndex].que_type !=
          0 ||
        this.questionData.question[this.questionData.questionIndex].selectTip +
          ''
      )
    },
    /* 是否显示下一题 问卷能下一题时并且题目类型不是单选 */
    showNext() {
      return (
        !this.questionData.finished &&
        this.questionData.canNext &&
        (![0, 7].includes(
          this.questionData.question[this.questionData.questionIndex].que_type
        ) ||
          this.questionData.question[this.questionData.questionIndex]
            .selectTip + '')
      )
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    this.getScreenHeight()
    this.getQuestionData()
  },
  methods: {
    getScreenHeight() {
      this.screenHeight = window.innerHeight + 'px'
    },
    bindChange() {
      this.questionData.change()
      /* 最后一题不自动跳转下一题 */
      if (
        this.questionData.question[this.questionData.questionIndex].que_filed ==
        'cna_setback'
      ) {
        this.computedScore()
      }
      if (
        this.questionData.question[this.questionData.questionIndex].que_filed ==
        'cna_weight'
      ) {
        this.computedBmi()
      }
    },
    computedBmi() {
      let bmi = this.getBmi()
      if (bmi < 18.5) {
        this.questionData.question[this.questionData.questionIndex].selectTip =
          '为身体健康,请考虑增肌塑形'
      } else if (bmi >= 28) {
        this.questionData.question[this.questionData.questionIndex].selectTip =
          '为身体健康,加强减脂哦'
      } else {
        this.questionData.question[this.questionData.questionIndex].selectTip =
          ''
      }
    },
    //获取bmi
    getBmi() {
      let height, weight
      this.questionData.question.map((item) => {
        if (item.que_filed == 'cna_height') {
          height = item.value
        }
        if (item.que_filed == 'cna_weight') {
          weight = item.value
        }
      })
      if (!height || !weight) {
        return
      }
      return weight / Math.pow(height / 100, 2)
    },
    //计算情绪分数
    computedScore() {
      let score = this.questionData.computedScore(89)
      let type = score >= -30 ? 0 : 1
      this.toastData = this.toastObj[type]
      this.showToast = true
    },
    //
    computedProblems() {
      let value =
        this.questionData.question[this.questionData.questionIndex].value
      if (value.includes(3) || value.includes(8)) {
        this.toastData = this.toastObj[2]
        this.showToast = true
      } else {
        this.questionData.next()
      }
    },
    computeDallergy() {
      let value =
        this.questionData.question[this.questionData.questionIndex].value
      if (value.length > 4) {
        this.toastData = this.toastObj[3]
        this.showToast = true
      } else {
        this.questionData.next()
      }
    },
    closeToast() {
      this.showToast = false
      this.questionData.next()
    },
    bindPreQuestion() {
      this.questionData.pre()
    },
    /* 下一题 */
    bindNextQuestion() {
      if (
        this.questionData.question[this.questionData.questionIndex].que_filed ==
        'cna_physical_problems'
      ) {
        this.computedProblems()
        return
      }
      if (
        this.questionData.question[this.questionData.questionIndex].que_filed ==
        'cna_diet'
      ) {
        this.computeDallergy()
        return
      }
      this.questionData.next()
      if (
        this.questionData.question[this.questionData.questionIndex].que_filed ==
        'cna_weight'
      ) {
        this.computedBmi()
      }
    },
    //隐藏题目
    hideQuestion() {},
    //显示题目
    showQuestin() {},
    bindConfirm() {
      if (this.questionData.que_allow_num == 1) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '问卷结果一旦确认就无法修改，您是否已确认所有选项所填无误'
          })
          .then(() => {
            this.bindSubmit()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.bindSubmit()
      }
    },
    bindSubmit() {
      let res = this.questionData.getResult()
      let params = {
        cna_new_id: this.$route.query.id || 0,
        info: res
      }
      this.$http.postBaseApp('que/CnaV2/saveCna', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          if (this.$route.query.no_recipe) {
            this.$toast('提交成功')
            setTimeout(() => {
              this.$betterwe.onAppCloseRoute()
            }, 500)
            return
          }
          this.$router.replace({
            path: '/cna-question-v2/loading',
            query: this.$route.query
          })
        } else if ((res.code = 412)) {
          if (this.$route.query.no_recipe) {
            this.$toast('问卷已填写')
            return
          }
          this.$dialog
            .confirm({
              title: '提示',
              message: '问卷已使用，是否直接查看结果？'
            })
            .then(() => {
              this.$router.replace({
                path: '/cna-question-v2/result',
                query: this.$route.query
              })
            })
            .catch(() => {
              // on cancel
            })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getQuestionData() {
      let params = {
        que_id: this.$route.query.queId || 0
      }
      this.$http
        .getBaseApp('que/CnaV2/getCnaInfo', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let step = 0
            res.data.question.map((item) => {
              if (item.que_type == 7) {
                item.step = step
                step++
              }
            })
            this.questionData = new Question(res.data)
          } else {
            this.$toast(res.msg)
          }
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.question {
  background-color: rgba(247, 247, 247, 1);
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.container {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 22px;
  box-sizing: border-box;

  .question-content {
    position: relative;
    z-index: 0;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 33px 46px;
    box-sizing: border-box;

    .que-content {
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }

    .btn-content {
      margin-top: 16px;
      overflow: hidden;
    }

    .next-step,
    .confirm {
      text-align: center;
      width: 188px;
      height: 50px;
      line-height: 50px;
      background: #9890fd;
      border-radius: 25px;
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      color: #ffffff;
      line-height: 50px;
    }
  }
}

.wrapper {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  background: #ffffff;
  border-radius: 12px;

  .w-title {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .w-image {
    width: 100%;
    height: 104px;
    object-fit: contain;
    min-height: 20px;
    margin-bottom: 2px;
  }

  .w-content {
    padding: 0px 20px 20px;
  }

  .w-text {
    margin-bottom: 26px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }

  .w-btn {
    text-align: center;
    height: 44px;
    background: #9890fd;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 44px;
  }
}
</style>
